export const logsData = [
    {
        updateTime: "2026-10-27", //时间戳
        update: [
            '团队费用合同增加合同金额限制',
            '管理员编辑增加合同附件修改功能',
            '团队费用合同删除‘蛋白代谢组测序’的项目模块，项目类型删除‘理化性质’',
            '发票退票审核通过，企微推送给销售'
        ],
        size: "large"
    },{
        updateTime: "2026-10-19", //时间戳
        update: [
            '团队费用合同纯分析项目选择纯分析类型增加原始数据重释放和纯分析',
            '信息统计增加团队费用使用情况',
            '修复团队费用合同纯分析无法搜索合同的bug'
        ],
        size: "large"
    },{
        updateTime: "2026-10-16", //时间戳
        update: [
            '新增团队费用合同',
            '合同导出新增勾选具体合同导出',
            '垫付款待退款优化，新增取消退款和备注填写',
            '管理员编辑优化，合同金额为0的自动设置已开票，已到款'
        ],
        size: "large"
    },{
        updateTime: "2026-10-09", //时间戳
        update: [
            '新增正式合同部分开票且开票部分全部到款，可以申请抵扣扣款合同，直接扣除预付款'
        ],
        size: "large"
    },
    {
        updateTime: "2026-09-20", //时间戳
        update: [
            '删除到款需要判断原始数据释放状态',
            '垫付的正式合同转扣款合同后，自动跳转到待退款，增加垫付款流程'
        ],
        size: "large"
    },
    {
        updateTime: "2026-09-18", //时间戳
        update: [
            '合同项目理化性质新增附件上传，需要上传需要做的理化列表',
            '合同申请发票新增开票日期备注，开票不是同一天必须填写',
            '新增定时任务，检查已申请签署并且已到款合同，自动撤销签署',
            '修复正式合同垫付款失败跳转待退款BUG',
            '返样 / 暂存样品和更多分析增加提醒备注',
            '宏基因组binning结题报告生成，样本限制改为160',
            '优化合同签署无法申请报错提示'
        ],
        size: "large"
    }, 
    {
        updateTime: "2026-09-03", //时间戳
        update: [
            '合同内容变更上传文件优化，可以原文件重新上传',
            '新增角色“审核”',
            '取消分析查看合同信息的权限',
            '合同存在原始数据释放审批提交或者已释放，裸测无法变更为测序分析'
        ],
        size: "large"
    },  
    {
        updateTime: "2026-08-21", //时间戳
        update: [
            '合同变更功能下物料邮寄信息增加展示，对具体可变更物料信息做出细分',
            '管理员编辑增加修改其他分析要求功能',
            '新增合同待签署企微通知，60天企微通知一次，80天通知一次，88天企微通知一次； 总共三次',
            '到款信息页面增加垫付款认领流程'
        ],
        size: "large"
    },
    {
        updateTime: "2026-08-14", //时间戳
        update: [
            '预付款合同新增垫付款状态',
            '修复部分页面查询出错的bug',
            '修改系统使用问题咨询人显示',
            '终止合同的合同金额验证修改为可小于等于原金额',
            '修复申请合同时物料申领数量限制计算bug',
            '修复销售团队统计导出缺少加急审批的bug'
        ],
        size: "large"
    },{
        updateTime: "2026-07-15", //时间戳
        update: [
            '合同审核页面待审核增加已收样子分类',
            '优化审核页面信息展示',
            '报告模板新增高级分析报告分类'
        ],
        size: "large"
    },
    {
        updateTime: "2026-07-10", //时间戳
        update: [
            '合同信息增加待收样',
            '合同基本信息增加硬盘购买信息',
            '所有合同类型都可以上传价格申请附件',
            '报告模板页面网页版报告、pdf结题报告等分类统一为标准分析结题报告',
            '优化部分信息页面展示'
        ],
        size: "large"
    },{
        updateTime: "2026-07-02", //时间戳
        update: [
            '增加删除垫付款功能',
            '老系统预付款合同增加管理员编辑功能',
            '纯分析评估删除，并类到合同审核',
            '修复标准分析具体类型可能不显示的bug',
            '修复合同信息页面前往开票可开票金额为0bug',
            '报告生成新增群体重测序项目类型',
            '合同变更在价格 / 样品不变的情况下， 裸测 -> 测序分析无法变更',
        ],
        size: "large"
    },{
        updateTime: "2026-06-10", //时间戳
        update: [
            '返样类型合同增加样品处理方式字段',
            '修复管理员编辑功能纯分析合同不能更改合同类型bug',
            '财务经理增加合同申请页面和信息统计页面权限',
            '合同申请页面增加企微推送规则显示',
            '被驳回退票申请的发票可再次申请退票',
            '商务系统如合同数据量变更并审批通过后：企微推送信息给龙欢，xx合同xx项目数据量发生变更，请注意数据量变化',
            '财务经理登记了到款待认领，企微推送给所有销售',
            '干冰取消安排，企微推送给销售',
            '修复干冰重新申请和纯分析重新申请的企微推送',
            '修复纯分析已暂停项目合同不能终止的bug'
        ],
        size: "large"
    },
    {
        updateTime: "2026-05-14", //时间戳
        update: [
            '客户单位增加弃用操作，管理员可操作',
            '优化总审批未到款申请原始数据 / 分析结果项目总金额统计，增加返样项目',
            '优化自动审批，纯分析合同如果只是正式 < -> 扣款，自动审批通过'
        ],
        size: "large"
    },{
        updateTime: "2026-05-13", //时间戳
        update: [
            '合同创建增加变更人、变更时间显示',
            '合同审核增加增值金额、变更审核人、变更审核时间显示',
            '扣款状态增加扣款人、扣款金额显示',
            '发票开具增加可开票金额、已申请开票金额、已开票金额显示',
            '管理系统收样增加收样人显示',
            '上传分析结果增加分析员显示'
        ],
        size: "large"
    },
    {
        updateTime: "2026-04-17", //时间戳
        update: [
            '单细胞项目增加上门和邮寄选择，上门通过邮箱和企业微信通知实验室',
            '优化到款导出，发票多个到款分开导出',
            '优化信息统计',
            '修复合同变更的自动审核，数据量或者测序平台有变化不能通过',
            '修复合同查看详情ONT数据量单位显示错误',
            '合同编辑和合同变更增加对样本数量的检查，必须大于等于管理系统样本数量'
        ],
        size: "large"
    },{
        updateTime: "2026-03-27", //时间戳
        update: [
            '合同信息增加初始销售搜索',
            '优化垫付款合同合同签署状态，已垫付自动撤销签署',
            '修复返样合同必须上传文件的bug',
            '硬盘规格增加20T'
        ],
        size: "large"
    },
    {
        updateTime: "2026-03-20", //时间戳
        update: [
            '信息统计销售团队统计新增团队审批未到款申请原始数据/分析结果/返样总金额与加急审批项目数量',
            '公司信息新增公司限额信息与公司编辑功能',
            '垫付款模块优化'
        ],
        size: "large"
    },
    {
        updateTime: "2026-03-17", //时间戳
        update: [
            '优化返样合同，合同金额可以为0',
            '新增垫付款信息，正式合同未到款可认领',
            '优化项目实验终止，已上机不能终止',
            '公司基本信息增加一年内已开发票金额，如果超过450w暂停开票',
            '修复三代检测平台数据错误bug'
        ],
        size: "large"
    }, {
        updateTime: "2026-03-06", //时间戳
        update: [
            '新增取消退票功能',
            '宣传品类物料增加分类',
            '正式合同、扣款合同新增项目类型“返样”',
            '合同新增返样状态信息展示',
            '合同生成功能新增抽提次数字段',
            '报告模板界面网页版报告分类新增“单细胞项目”类目',
            '分析角色新增合同信息页面展示权限'
        ],
        size: "large"
    },
    {
        updateTime: "2026-01-28", //时间戳
        update: [
            '优化合同金额为0的信息展示',
            '合同申请新增价格申请截图，合同价格低于报价表需提交',
            '销售信息统计增加已下机未开票金额、已分析结束未开票金额',
        ],
        size: "large"
    },
    {
        updateTime: "2025-12-11", //时间戳
        update: [
            '合同签署增加手机端网页版',
            '结题报告增加宏基因组binning',
            '商务流转增加删除到款功能和删除到款记录',
            '纯分析评估人增加合同详情查看'

        ],
        size: "large"
    },
    {
        updateTime: "2025-12-01", //时间戳
        update: [
            '优化预付款合同增值金额的输入',
            '优化合同基础信息显示，全部项目实验终止显示终止实验',
        ],
        size: "large"
    },{
        updateTime: "2025-11-25", //时间戳
        update: [
            '实验终止新增分析金额及服务费（返样）修改',
            '三代测序项目更改数据量选择限制',
            '新增销售经理编辑合同销售功能，未到款发票对应同步',
            '发票认领，销售只能选择对应自己的发票',
            '优化合同导出和发票导出，增加初始销售',
            '优化实验终止，终止金额改为最终结算金额',
            '修复合同基础信息显示，无原始数据合同无合同签署',
        ],
        size: "large"
    }, {
        updateTime: "2025-11-24", //时间戳
        update: [
            '实验终止新增分析金额及服务费（返样）修改',
            '三代测序项目更改数据量选择限制',
            '新增销售经理编辑合同销售功能，未到款发票对应同步',
            '发票认领，销售只能选择对应自己的发票'
        ],
        size: "large"
    },{
        updateTime: "2025-11-13", //时间戳
        update: [

            '新增销售取消开票，批量取消开票',
            '合同终止优化，测序分析、裸测可以实验终止，无需终止合同',
            '信息统计优化，销售经理增加团队统计显示，离职销售发票到款信息归档到销售经理',
            '结题报告生成增加eDNA浮游、宏转录组，添加水印改为添加公司结题报告章',
            '修复合同模板生成项目内容重复的bug',
            '合同项目类型硬盘购买增加5T、6T、10T、12T',
            '纯分析合同同步到管理系统纯分析项目文件中',
            '修复合同签署，测序分析、裸测的其他类型不能申请合同签署',
        ],
        size: "large"
    },
    {
        updateTime: "2025-11-05", //时间戳
        update: [

            '结题报告生成增加裸测全基因组甲基化测序，公司选择增加江苏凌帆 / 南京微合',
            '修复合同签署文件读取失败的BUG',
            '增加纯分析拒绝的企业微信通知，干冰企业微信推送改为实时推送'
        ],
        size: "large"
    }, {
        updateTime: "2025-11-04", //时间戳
        update: [
            '优化合同信息导出，包括合同分类、可开票金额等',
            '增加纯分析审核合同信息导出，销售搜索',
            '优化企业微信通知，已处理数据不通知'
        ],
        size: "large"
    }, {
        updateTime: "2025-10-31", //时间戳
        update: [
            '优化合同信息展示，合同无原始数据不展示原始数据释放阶段',
            '增加合同签署、干冰安排企业微信通知'
        ],
        size: "large"
    },{
        updateTime: "2025-10-29", //时间戳
        update: [
            '结题报告生成优化，增加样品名称检查',
            '项目款认领记录增加到款金额、收款单位、付款单位的筛选',
            '合同终止实时审批增加预付款类型',
            '修复合同终止操作人缺失的BUG',
            '三代测序项目数据量填写规则更改。数据量全为可选，必须选择至少一种数据量，且单选时三代数据量为必选项'
        ],
        size: "large"
    }, {
        updateTime: "2025-10-24", //时间戳
        update: [
            '已开票合同管理员编辑优化，可更改合同金额，金额不能低于当前合同已开发票金额',
            '合同邮寄增加修改邮寄负责人功能',
            '增加扣除记录页面',
            '信息统计增加扣除金额统计',
            '优化结题报告生成，增加水印参数',
            '纯分析合同提交增加企业微信通知',
            '优化待签署合同界面，去掉无原始数据的项目',
        ],
        size: "large"
    }, {
        updateTime: "2025-10-16", //时间戳
        update: [
            '增加结题报告生成页面',
            '修复到款信息审核页面收款单位显示bug',
            '合同已提交页面增加待签署分类'
        ],
        size: "large"
    },
    {
        updateTime: "2025-09-25", //时间戳
        update: [
            '新增合同合并签署',
            '新增客户联系人编辑白名单',
            '合同生成增加乙方公司地址，除上海凌恩外无法添加水印',
            '合同签署申请增加验证，无原始数据合同无法申请',
        ],
        size: "large"
    },
    {
        updateTime: "2025-09-19", //时间戳
        update: [
            '优化纯分析流程，无需申请合同签署',
            '合同签署可以执行时间为已通过质检，关闭申请为：全款到账',
            '申请合同签署可以提交带老师手签的合同附件，申请时选择线下签署',
            '优化合同生成、客户联系人，增加通讯地址',
            '优化合同签署状态，甲方已签分为线上和线下',
            '合同签署增加签署链接，如果签署短信未收到，可直接发送签署链接',
            '合同项目类型的测序平台增加三代平台选择',
            '优化合同签署已撤销颜色',
            '文件自动同步时间点放到每个分类内',
            '自动审批改为实时审批'
        ],
        size: "large"
    },
    {
        updateTime: "2025-09-15", //时间戳
        update: [
            '优化自动生成合同，删除检测平台',
            '优化合同签署释放分析结果，无需审核直接申请，申请条件：数据下机了或者销售填了信息采集表',
            '优化合同签署、分析结果释放状态条，调整颜色',
            '优化合同签署状态显示，已到款正式合同或审核已通过的扣款和研发合同签署状态为自流转'
        ],
        size: "large"
    },
    {
        updateTime: "2025-09-12", //时间戳
        update: [
            '纯分析项目变更合同金额发生变化且审批通过且已安排分析员，给销售 + 分析员发邮件告知',
            '合同当前状态增加分析结果释放状态',
            '合同签署正式上线，所有销售都可申请',
            '合同模板生成页面修复部分权限角色无法生成模板bug'
        ],
        size: "large"
    },
    {
    updateTime: "2025-09-05", //时间戳
    update: [
        '客户联系人增加剩余金额查询排序功能，可以按区间查询',
        '增加合同发票创建所属销售展示，包括离职销售',
        '优化销售已开票，到款金额统计',
        '合同签署状态整合至当前状态展示，上传分析结果后才可申请合同签署'
    ],
    size: "large"
}, {
        updateTime: "2025-08-22", //时间戳
        update: [
            '合同信息增加合同签署状态显示，增加合同终止审核人和审核时间显示',
            '增加合同签署文件下载功能',
            '增加管理员终止功能，管理员编辑可编辑合同金额为0',
            '修复合同签署审核页面客户联系人不显示bug',
            '导出增加按截止时间查询功能',
            '优化合同直接终止功能，记录所有终止记录',
        ],
        size: "large"
    },
    {
        updateTime: "2025-08-08", //时间戳
        update: [
            '编辑合同信息时可修改合同名称，修复合同名称限制符号报错问题',
            '销售资料页面增加培训资料信息',
            '修复合同已提交页面数字提示不显示问题',
            '合同终止修改为可单独终止每一项项目，所有项目均终止时，合同默认终止；合同项目信息增加项目状态条目，可查看已终止项目',
            '管理员编辑合同时可更改项目金额与合同金额为0',
            '修复项目信息分析要求重复bug',
        ],
        size: "large"
    },
    {
        updateTime: "2025-08-01", //时间戳
        update: [
            '公司信息增加三方报价信息',
            '编辑物料申请功能优化，自动去除当前无法申请的物料',
            '审批功能优化，点击审批时更新审批信息，避免信息二次审核',
            '修复合同申请内项目信息中标准分析具体类型显示错误问题',
            '修复发票开票 - 已开票页面内发票下载发生错误的问题',
            '新增iGUT模块项目申请',
            '优化商务文件同步share服务器',
        ],
        size: "large"
    },
    {
        updateTime: "2025-07-23", //时间戳
        update: [
            '预付款转移新增收款方销售显示，修复入账合同中收款方客户联系人显示错误问题',
            '到款信息导出中到款时间和到款金额显示调整为分开两列',
            '新增报告模板批量下载功能',
            '优化发票开票中的发票识别',
            '修复物料申请出现的重复提交',
            '合同名称添加对特殊字符限制',
        ],
        size: "large"
    },
    {
        updateTime: "2025-07-11", //时间戳
        update: [
            '自动审批增加审批原因显示',
            '修复合同基础信息当前状态显示错误bug',
            '修复项目变更信息显示错误的问题，查看变更信息内修改为全部项目信息展示',
            '优化导出功能时间选择，开始和结束日期分左右展示',
            '修复可选列设置后，重新登录又变为默认的BUG',
            '规范生成合同中的金额书写方式，统一保留两位',
            '公司信息可以一键全复制',
            '优化原始数据下载器，可以设置单个下载，解决关闭、中断无法保存任务的BUG',
        ],
        size: "large"
    }, {
        updateTime: "2025-07-04", //时间戳
        update: [
            '修复邮寄申请收件人电话无法自动获取的BUG',
            '更新合同申请数据量单位显示',
            '新增合同终止，合同变更自动审批',
            '合同当前状态新增分析结果及时间',
            '优化合同变更申请，部分/全部释放原始数据，不允许把裸测变更为测序分析；部分/全部释放分析结果，不允许把测序分析变更为裸测',
            '优化合同当前状态显示，加入合同类型，合同分类，是否返样',
            '修复合同变更审核管理系统样本数量不一致的BUG',
            '优化合同变更界面显示，未发生改变的项目不显示',
        ],
        size: "large"
    }, {
        updateTime: "2025-06-20", //时间戳
        update: [
            '销售资料挂载到SYS01服务器，商务系统会直接获取销售资料分类添加、修改的内容',
            '新增合同编辑、管理员编辑、合同变更、合同终止流程图',
            '新增管理员编辑说明',
            '新增预付款转移合同',
            '新增销售团队信息汇总',
            '修复合同导出已开票金额和可开票金额出错的BUG',
            '增加到款时间显示',
            '销售资料和各种模板报告支持大小写搜索'
        ],
        size: "large"
    }, {
        updateTime: "2025-06-13", //时间戳
        update: [
            '优化微生态保护液邮寄，分为商务邮寄和实验室邮寄',
            '优化微生态保护液合同变更',
            '修复草稿箱编辑实验过程无法保存的BUG',
            '合同已提交增加已开票金额展示，合同导出增加可开票、已开票金额列',
            '合同状态增加收样时间和原始数据释放时间',
            '新增已驳回合同（无上机项目）可以直接终止',
            '首行表头固定'
        ],
        size: "large"
    }, {
        updateTime: "2025-06-06", //时间戳
        update: [
            '新增预付款合同可以自动生成',
            '优化上传邮寄资料，支持多文件同时上传，邮寄可以下载完整附件或者单个文件',
            '新增已送样未开票项目按月汇总给程燕，包括每个项目具体状态',
            'pdf报告改为pdf结题报告',
            '报告模板新增报账结题报告',
            '新增研发合同增加裸测选项',
            '公司信息统计增加总计行'
        ],
        size: "large"
    }, {
        updateTime: "2025-05-23", //时间戳
        update: [
            '修复变更待审批无法查看的BUG',
            '优化物料词库查看，销售只能查看有库存，能申请的',
            '定量选择界面优化，每种类型都有一个样品数量，和金额',
            '优化合同生成格式',
            '技术资料上系统',
        ],
        size: "large"
    }, {
        updateTime: "2025-05-21", //时间戳
        update: [
            '优化合同金额= 预付款合同金额+正式合同金额(优化)',
            '添加统计预付款合同金额、尾款金额',
            '优化项目选择界面',
            '优化保护剂选择，支持同一种保护剂多规格申请',
            '定量选择界面优化，每种类型都有一个样品数量',
            '预付款扣款合同中（微生态保护液，其他）当前状态改成：合同审核->扣款状态',
            '实验室和管理员账号才可以审批合同终止',
            '修复发票信息中发票抬头无法搜索的BUG',
            '优化合同名称生成'
        ],
        size: "large"
    }, {
        updateTime: "2025-05-19", //时间戳
        update: [
            '合同名称生成功能修改，销售-客户-样品数量个-项目类型”改成“样品数量个-项目类型-测序分析/裸测/纯分析”',
            '管理员编辑增加更改甲方联系人功能',
            '邮箱验证优化，自动排除头尾空格',
            '项目信息结构修改，项目可添加多个样品数量和多个样品数据量，项目添加实验过程选择(引物合成不可取消)',
            '微生态保护液添加规格选择',
            '物料词库增加删除功能按钮',
            '增加中文材料模板',
            '公司统计信息增加已收样未开票金额'
        ],
        size: "large"
    }, {
        updateTime: "2025-05-09", //时间戳
        update: [
            '新增服务费(返样)为0时填写原因',
            '合同变更、终止、纯分析审核增加客户搜索',
            '合同生成优化，生成界面优化，新增水印参数',
            '合同项目模块新增分析要求',
            '变更信息界面补充分析要求信息展示优化'
        ],
        size: "large"
    }, {
        updateTime: "2025-05-06", //时间戳
        update: [
            '新增合同时裸测和测序分析增加是否抽提选项（必选）',
            '生成合同会检查客户信息，电话缺失会提示',
            '合同总金额计算优化，加入服务费(返样)，增加累加按钮',
        ],
        optimize: [
            '优化合同生成界面以及合同生成结果',
            '修复研发合同多个项目无法提交的bug',
            '优化合同变更，管理系统释放了原始数据的扣款合同不允许变更为正式合同',
            '修复部分页面进入后数据不加载的bug'
        ],
        size: "large"
    }, {
        updateTime: "2025-04-28", //时间戳
        update: [
            '新增合同模板更新日志',
            '销售资料页面开放给技术支持',
            '新增到款信息的到款时间排序',
            '新增/编辑/变更合同的客户剩余金额改为可扣款金额',
        ],
        optimize: [
            '修改检测平台选择显示效果，修复合同变更检测平台无法选择bug',
            '优化合同申请页面合同驳回原因显示效果，整合至合同审核状态',
            '正式合同转预付款合同当前状态显示修改，去除该类合同邮寄、开票、变更等功能',
            '到款金额，在添加到款信息的时候，直接显示开票金额',
            '修复扣款合同变更审核时未检查剩余金额导致客户金额剩余金额小于0的bug'
        ],
        size: "large"
    }, {
        updateTime: "2025-04-17", //时间戳
        update: [
            '合并开票规则修改，部分开票合同也可合并开票，合并开票时合同剩余可开票金额需完全开票',
            '增加销售资料模块页面',
            '合同项目模块信息增加检测平台选择',
            '优化客户联系人导出，新增联系人各种金额统计',
            '增加发票退票验证，到款发票不能退票',
        ],
        size: "large"
    }, {
        updateTime: "2025-04-08", //时间戳
        update: [
            '扣款合同新增微生态保护剂类型',
            '信息统计页面新增物料信息统计与物料销售信息统计展示及导出',
            '邮寄扫描信息页面新增申请邮寄功能,可以多次邮寄',
            '物料入库新增物料名称搜索，物料申请新增销售搜索',
        ],
        size: "large"
    }, {
        updateTime: "2025-03-31", //时间戳
        update: [
            '新增已通过合同管理员编辑权限',
            '新增报告模板更新文档',
            '合同、发票、邮寄导出新增备注列',
            '修复微生态保护液实验邮寄后，资料邮寄状态未改变的BUG',
            '合同变更项目信息新增管理系统样本数量',
            '合同变更逻辑修改，已上机项目不能删除可以修改',
            '研发合同新增合同变更功能',
            '合同终止逻辑修改，管理系统内存在且上机测序的项目不能终止',
        ],
        size: "large"
    }, {
        updateTime: "2025-03-25", //时间戳
        update: [
            '新增邮寄导出',
            '优化客户信息导出，优化按日期导出',
            '新增财务可以删除待认领记录',
            '新增合同变更项目类型检查，项目管理系统存在+上机测序的项目不能删除',
            '变更审批内，新增项目在项目管理系统内的状态：是否收样、是否质检'
        ],
        size: "large"
    }, {
        updateTime: "2025-03-20", //时间戳
        update: [
            '纯分析评估人增加合同模板、报告模板',
            '合同申请已提交内增加客户单位及搜素',
            '新增合同释放原始数据/分析结果状态，每天下午6点同步',
            '新增合同编辑、合同变更项目类型检查，项目管理系统存在的项目不能删除',
            '合同申请“已提交”内增加退回合同分类',
        ],
        optimize: [
            '研发合同退回后、待审核可以修改',
            '扣款合同如果检测到项目管理系统里面数据/分析结果释放了，不允许再变更合同',
            '优化扣款合同变更可扣款金额计算逻辑'
        ],
        size: "large"
    }, {
        updateTime: "2025-03-18", //时间戳
        update: [
            '发票退票增加开票时间显示，发票退票增加退票时间',
            '增加销售助理物料词条编辑权限',
            '新增发票信息、发票开票、到款信息导出功能'
        ],
        optimize: [
            '合同信息项目分析平台数据量显示优化',
            '修复商务系统与项目管理系统项目类型不同步的bug',
            '修复合同无法终止的bug',
            '优化邮寄功能，发票审核驳回，邮寄也为已驳回',
            '优化合同信息导出时间，增加防重复提交'
        ],
        size: "large"
    }, {
        updateTime: "2025-03-14", //时间戳
        update: [
            '增加合同终止功能，增加合同终止申请记录页面',
            '优化合同导出功能，实现按年、月、日导出',
            '到款信息增加收款单位',
            '增加发票退票页面发票号展示',
            '新增到款信息展示，新增发票到款信息是否存在认领信息展示',
            '补全部分纯分析合同的审核人、审核时间'
        ],
        size: "large"
    }, {
        updateTime: "2025-03-11", //时间戳
        update: [
            '优化合同创建时间的更新，编辑或者合同变更成功会更新创建时间',
            '优化项目款认领功能，销售可以查看项目款认领记录',
            '优化合并开票，支持不同页选择合同一起开票',
            '优化合同可开票金额显示',
            '研发合同添加纯分析类型'
        ],
        size: "large"
    }, {
        updateTime: "2025-03-06", //时间戳
        update: [
            '增加到款金额到款时间搜索功能',
            '优化纯分析审批流程，增加纯分析合同发票同时审核功能',
            '纯分析合同取消待评估状态',
            '增加合同变更当前与变更前内容展示',
        ],
        size: "large"
    }, {
        updateTime: "2025-03-04", //时间戳
        update: [
            '商务系统内客户信息的编辑权限开放给销售助理主管',
            '增加报账资料的备注提示',
            '修复已驳回发票重新提交无法继续审核的BUG',
            '邮件/扫描信息加上客户列',
            '合同申请内添加合同变更申请记录，合同增加是否变更合同标签列',
        ],
        size: "large"
    }, {
        updateTime: "2025-03-03", //时间戳
        update: [
            '优化邮寄申请界面',
            '如果合同只有一张发票的 是否连号 / 是否同一天 显示为：NA',
            '每个发票添加发票抬头选项',
            '修复发票识别的BUG'
        ],
        size: "large"
    }, {
        updateTime: "2025-02-28", //时间戳
        update: [
            '优化报账资料上传，改为邮寄时上传报账资料，开票上传试剂清单',
            '优化邮寄申请，邮寄内容展示',
            '优化发票信息展示，增加合同发票总数，是否同一天，是否连号',
            '修复物料重新提交不能删除物料详情的BUG',
            '修复发票开票个别发票无法识别的BUG',
            '新建客户单位，检查是否有重复税号，客户信息模块增加提示备注',
            '优化客户单位、课题组删除逻辑，存在绑定无法删除',
            '修复客户联系人对应课题组无法删除的BUG',
            '修复纯分析合同评估通过后还能被编辑的BUG',
            '增加邮寄信息的合同编号、销售、负责人的搜索',
            '申请合同界面增加新的备注提示',
            '销售助理增加物料暂停申请的权限',
            '物料剩余数量逻辑修改，申请的时候物料自动减少，如果被取消后加回去',
            '增加报告模板中网页版报告的子分类',
            '修复其他合同转研发合同无法提交的BUG',
            '商务助理增加发票审批权限',
            '优化商务助理的待邮寄内容，增加邮寄待审核分类',
            '增加发票开票可以取消开票的功能'
        ],
        size: "large"
    }, {
        updateTime: "2025-02-24", //时间戳
        update: [
            '优化结题报告扫描的选择逻辑，没有上传结题报告，不能选择',
            '新增合同分类：研发合同',
            '优化合同审批，合同拒绝后，相关发票和邮寄也会同步拒绝',
            '优化合并开票，计算总金额默认填上',
            '优化报账资料上传，可以取消',
            '合同变更规则优化（如果合同开了发票，但是开具的所有发票都被退票了，该合同可以变更）',
            '优化申请开票，开票单位默认为合同相关开票单位'
        ],
        size: "large"
    }, {
        updateTime: "2025-02-21", //时间戳
        update: [
            '退票申请增加退票原因',
            '优化系统内创建人和销售的显示',
            '优化发票信息相关附件的下载操作',
            '优化合同申请项目金额与合同金额的检验',
            '优化申请邮寄的选择判断与邮寄内容，增加报账资料扫描件',
            '优化发票开票中发票抬头的比较方式',
            '优化申请开票时默认销售为合同对应销售',
            '优化合同编辑功能，可以编辑或者新增发票、邮寄信息，也可以取消发票申请和邮寄',
            '增加销售助理的发票、邮寄信息的操作权限'
        ],
        size: "large"
    }, {
        updateTime: "2025-02-18", //时间戳
        update: [
            '修复纯分析审批申请人不显示问题，增加评估人显示，增加部分信息筛选功能',
            '扣款合同/正式合同里面的增值金额都改成：NA',
            '在发票审批和发票开具页面增加下载报账资料功能',
            '增加到款信息修改功能，增加新增到款信息时发票金额展示',
            '合同变更审批增加申请人和签单业务员',
            '发票申请更改销售助理可选择的销售列表',
            '优化纯分析审批查看权限，管理员查看所有，分析员查看自己的',
            '申请开票添加新的提示：如果需要把单价数量单位规格开到发票里，请在发票备注里写清楚。',
            '开票审批增加合同编号、发票抬头 、客户筛选',
            '修复新增和删除客户联系人的BUG',
            '修复编辑合同金额不变的BUG',
        ],
        size: "large"
    }, {
        updateTime: "2025-02-12", //时间戳
        update: [
            '新增客户单位类型：个人',
            '优化合同变更，合同变更未审核之前可以一直变更',
            '合并开票规则修改',
            '修复部分信息搜索功能无作用',
            '修复pdf模板页面信息无法获取问题',
            '优化物料申请导出功能'
        ],
        size: "large"
    },
    {
        updateTime: "2025-02-10", //时间戳
        update: [
            '新增合同变更与合同变更审核功能',
            '新增未申请开票合同审核前可编辑重新提交功能',
            '修复客户单位信息与发票内信息不一致问题',
            '销售助理增加物料入库权限，技术支持增加添加编辑物料信息权限',
            '物料信息缩略图修改为附件，可下载',
            '增加干冰申请设置送达时间，干冰安排可设置负责公司',
            '增加英文材料方法写作模板下载'
        ],
        size: "large"
    },
    {
        updateTime: "2025-01-23", //时间戳
        update: [
            '解决客户课题组缺少”对应销售姓名“ 创建的时候也没用这个选项；编辑的时候也不能修改，已解决',
            '合同信息规则展示紧凑已解决',
            '网络波动造成的重复插入',
            '增加首次登录时更新日志提醒',
            '发票开票内，识别发票增加开票日期并导入到系统记录',
            '修复客户记录被删除合同审核无法打开的BUG',
        ],
        size: "large"
    },
    {
        updateTime: "2025-01-22", //时间戳
        update: [
            '商务助理的功能界面优化，增加发票信息 / 邮寄信息，删掉物料管理 / 合同模板 / 报告模板',
            '商务流转内发票开票增加客户信息',
            '增加合并邮件/合并开票/合并释放原始数据规则',
            '增加单独分析员角色：高燚 / 李军辉 / 查富蓉 登录商务系统',
            '客户联系人增加创建人 ，删除客户单位查看详情',
            '合同申请/已提交内增加合同审批人 /  发票审批人',
            '增加合同号复制和公司信息复制',
        ],
        size: "large"
    }, {
        updateTime: "2025-01-20", //时间戳
        update: [
            '增加到款信息的筛选功能',
            '客户信息重新导入',
            '发票状态颜色改变',
            '合同申请界面展示合同相关信息解释',
        ],
        size: "large"
    }, {
        updateTime: "2025-01-18", //时间戳
        update: [
            '优化合同状态说明展示',
            '增加下载邮寄资料功能',
            '增加邮寄申请添加扫描件，增加商务专员上传扫描件功能',
            '优化部分标签颜色展示',
            '增加报告模板模块',
            '增加合并添加到款以及单独添加到款功能',
            '修复物料申请重新提交可能信息出错的问题',
            '转预付款页面增加页面分类'
        ],
        size: "large"
    }, {
        updateTime: "2025-01-17", //时间戳
        update: [
            '财务登录界面优化',
            '合同资料邮寄：未申请和已提交用不同的颜色展示',
            '增加发票信息到款金额展示',
            '所有邮寄合并收件人、收件人电话 、收件地址',
            '合同每个状态增加详情说明',
            '到款信息分类并加上销售、客户列',
            '扩增子数据量限制是>=10000；不是大于10000',
            '销售添加客户联系人的时候检查客户邮箱，不允许出现公司邮箱后缀',
            '在物料申请界面，增加邮寄负责人提醒',
            '添加合同样品数量后面加一个项目金额，所有项目以及选择的分析项目的金额需要等于合同金额',
            '宣传品，礼品，干冰邮寄由销售助理负责'
        ],
        size: "large"
    }, {
        updateTime: "2025-01-16", //时间戳
        update: [
            '商务审批添加具体分类',
            '检测平台顺序调整为二代测序  /  三代测序 / hic测序 / ont测序的顺序展示',
            '管理员角色合同信息不需要数字提醒',
            '全部合同里申请合并开票和申请合并邮寄会检查合同',
            '公司资料改为从服务器上提取',
            '优化合同和发票申请界面，移动签订地址，增加报账资料邮寄提示',
            '优化邮寄申请的内容填写，增加结题报告和营业执照',
            '修复项目模块数量限制提示的BUG',
            '商务系统增加出纳角色',
            '增加发票信息到款金额'
        ],
        size: "large"
    }, {
        updateTime: "2025-01-15", //时间戳
        update: [
            '修复合同模板展示BUG',
            '修复物料词库编辑备注无响应的BUG',
            '增加宣传品和礼品最大申请次数200，超过报错',
            '优化合同申请项目数据量填写界面',
            '物料邮寄/干冰安排/发票退票/发票开票/合同邮寄增加全部分类',
        ],
        size: "large"
    }, {
        updateTime: "2025-01-14", //时间戳
        update: [
            '合同申请根据选择的项目不同，自动生成对应检测平台模块，并可填写数据量',
            '物料申领添加备注',
            '合同审核页面和合同详情页面添加项目详情信息，合同审核页面添加保护剂申请数量信息展示',
        ],
        size: "large"
    }, {
        updateTime: "2025-01-11", //时间戳
        update: [
            '修复个性化分析附件和个性化分析金额上传和判定问题',
            '修复保护剂邮寄信息商务专员能看到问题',
            '修复邮寄物料失败问题',
            '修复发票申请无法提交问题',
            '解决合同编号冲突的BUG',
        ],
        optimize: [
            '优化合同、发票份数选择',
            '增加物料申领数字提醒',
            '增加合同模板二级分类',
            '合同模板顺序修改',
            '合同界面增加邮寄详情，取消的合同邮寄可以在邮寄详情再次申请',
            '增加邮寄分类信息',
            '优化公司信息展示，增加公司分类',
            '去除测序分析/裸测内的纯分析选项',
            '物料邮寄增加负责人',
            '优化导入发票模块'
        ],
        size: "large"
    }, {
        updateTime: "2025-01-10", //时间戳
        update: [
            '商务系统整体UI优化，包括申请界面，信息展示，整体布局等',
            '取消开票审批详情，增加合同编号展示',
            '优化开票审批界面',
            '物料申领添加分类',
            '管理员添加：客户单位 / 客户联系人 / 客户课题组 导出权限',
            '优化发票上传模式，可以查看上传发票pdf信息',
            '删除发票记录，留存发票信息展示，增加发票信息的分类展示',
            '增加合同模板模块',
            '优化邮寄信息申请界面'
        ],
        size: "large"
    }, {
        updateTime: "2025-01-06", //时间戳
        update: [
            '优化客户信息功能管理，详情信息显示在列表中',
            '各个信息页面的时间填写增加默认当前时间时分秒',
            '修复申请开票页面可开票金额为0的问题',
            '修复合同信息页面标签查询失败的问题',
            '合同申请的物料申请增加多选功能',
        ],
        size: "large"
    }, {
        updateTime: "2025-01-03", //时间戳
        update: [
            '邮寄信息按要求归到对应的人处理',
            '物料邮寄增加数字提醒',
            '合并邮寄 / 合并开票保证是同一个销售 + 同一个客户联系人',
            '审核时间区分：合同审核时间，发票审核时间',
            '合同申请归类优化，增加待邮寄  前端写的可以加上',
            '发票信息增加销售，负责人，合同编号显示',
            '发票信息增加审核状态分页',
            '增加其他商务信息页面相关合同编号展示',
            '发票详情页面信息拆分至主页面展示，详情页面删除',
            '部分信息的详情页面信息整合至列表展示中',
        ],
        size: "large"
    },
    {
        updateTime: "2025-01-02", //时间戳
        update: [
            '物料申请详情干冰与非干冰申请显示优化',
            '优化物料状态显示',
            '合并邮寄 / 合并开票增加销售 + 单位选择',
            '销售增加到款汇总显示',
            '物料词库增加物料类型分页，词库信息按库存数量排序',
            '合同与发票信息增加审核时间区分',
            '增加技术支持上传缩略图',
            '删除邮寄信息下载附件功能',
            '优化邮寄信息补全信息填写必要性',
            '优化合同申请页面内容显示',
            '修复技术支持无法登录bug'
        ],
        size: "large"
    },
    {
        updateTime: "2024-12-31", //时间戳
        update: [
            '合同处理状态增加“发票未申请”',
            '详情页面优化，增加显示合同微生态保护液类型申请物料的物料详情，增加邮寄信息的快递单号及上传时间显示',
            '合同申请页面功能整合，添加合并开票选项',
            '物料申请添加干冰申请和销售助理安排干冰申请功能，取消物料申请审核',
            '开票审核增加具体每张发票负责人选择',
            '公司资料文件归类，下载附件改为下载资料',
            '增加技术支持登录商务系统',
            '增加客户联系人销售名称搜索功能',
            '修复合同合并开票，合同可开票金额错误的bug',
            '增加预付款增值金额的到款判断',
        ],
        optimize: [
            '优化合同相关时间，仅保留审核时间与拟定时间',
            '快递单号填写逻辑优化',
            '商务专员主页页面显示顺序优化',
        ],
        size: "large"
    },
    {
        updateTime: "2024-12-28", //时间戳
        update: [
            '修复销售界面权限访问，无法编辑公司和客户信息',
            '创建合同默认选择是正式',
            '创建合同的时候，合同附件是必填项，合同只审核一次',
            '合同信息添加申请合同邮寄、合并邮寄选项',
            '物料内添加暂停选项 ，选择暂停后，销售无法申请该物料',
        ],
        optimize: [],
        size: "large"
    },
    {
        updateTime: "2024-12-27", //时间戳
        update: [
            '优化合同Tab分类',
            '优化合同/发票状态分类',
            '项目分类额外添加硬盘购买',
            '申请开票补充，开票单位跟着每一张发票，发票记录可以上传报账资料',
            '公司信息内添加暂不开票，无法选择该公司开票',
            '添加合同负责人，该人负责合同邮寄，添加发票负责人，该人负责发票邮寄',
            '优化正式合同的同步规则',
            '优化物料管理名称修改、信息补全名称修改',
            '发票到款内不允许删除',
            '添加到款信息，添加客户单位，根据选择的客户单位，提出该单位未到款的发票和金额',
            '到款信息里面添加一个分类： 项目款认领， 所有销售可以看到， 销售补齐发票号信息， 财务审核，审核通过后到到款信息内',
        ],
        optimize: [],
        size: "large"
    }, {
        updateTime: "2024-12-24", //时间戳
        update: [
            '主界面条目排序更新',
            '合同信息排版和功能添加，增加未到款、待审核合同',
            '优化正式合同和扣款合同的排序，选择合同分类后，对应合同类型按序排列',
            '优化合同申请项目类型添加，只有测序分析 / 裸测 / 纯分析 有项目类型（包括预付款扣款）',
            '增加更新日志展示',
            '商务系统内审批通过的合同同步到共享服务器',
            '优化项目类型添加形式，可以填写项目分类 /  项目类型 / 样品数量 / 样品数据量'
        ],
        optimize: [],
        size: "large"
    },
    {
        updateTime: "2024-12-19", //时间戳
        update: [
            '合同审核可以审核两次，附件提交后再次审核',
            '合同类型改成合同分类，项目类型改成合同类型',
            '合同分类和合同类型进行绑定',
            '新建合同，合同类型为测序分析时，增加标准分析、高级分析、个性化分析',
            '新建合同可以添加多个（项目类型、样品数量）',
            '合同相关时间平铺展示',
            '合同信息界面已提交操作添加：提交合同，申请开票',
            '已提交合同信息做分类： 所有  /  未提交合同（数字提醒） / 未开票（数字提醒）',
            '新建合同添加进度查询，包括合同审核状态、合同邮寄状态、发票邮寄状态、项目到款状态',
            '优化审核页面',
            '客户信息展示优化，增加详情操作'
        ],
        optimize: [],
        size: "large"
    },
    {
        updateTime: "2024-12-11", //时间戳
        update: [
            '保护剂更改为在合同申请，审核通过后流转到物料管理',
            '物料词库和物料入库由商务部门管理',
            '物料邮寄，保护剂实验室负责邮寄，其他由商务负责',
            '添加物料词库可以上传图片',
            '调整物料申请和物料审核界面，界面更加紧凑',
            '物料审核和物料邮寄合并为一个界面操作（除了保护剂）',
            '物料邮寄可以分多次上传快递单号，快递单号支持扫描填写，自由选择是否完成邮寄',
            '优化合同申请界面，选择合同类型时，项目类型对应填充默认值',
            '优化合同发票邮寄申请界面，对应界面增加消息提示，例如注：如需开票，请点击下方开关"添加发票信息"；如需邮寄，请点击下方开关"添加邮寄信息"等',
            '优化合同开票邮寄同时提交，审核时在同一界面',
            '优化开票申请界面，合同选择通过合同编号选择',
            '优化邮寄申请，收件人可以通过输入框联想自由填写',
            '优化开票邮寄同时申请，商务专员处理时可以同时处理',
            '优化商务系统合同编号，使用新的生成规则'
        ], //更新
        optimize: [], //优化
        size: "large"   //normal / large
    },
]
